import { useTheme } from '@mui/material';

export enum StylePages {
  reports = 'reports',
  dashboards = 'dashboards',
}

export default function useStyle(page: string) {
  const theme = useTheme();

  const style = {
    [StylePages.reports]: {
      entityBackgroundColor: theme.palette.colors.neutrals[150],
      fieldHoverBackgroundColor: theme.palette.colors.neutrals[300],
    },
    [StylePages.dashboards]: {
      entityBackgroundColor: theme.palette.white.main,
      fieldHoverBackgroundColor: theme.palette.colors.neutrals[200],
    },
  };

  return style[page];
}
